/**
 * AI-mode resolver — combines per-account mode + off-target stance + hot-lead
 * override into the effective mode for a given conversation.
 *
 * Source: EPIC-07 US-084..US-090.
 *
 * Output enum:
 *   'auto'    — AI sends without human review.
 *   'review'  — AI proposes, human approves.
 *   'manual'  — AI does nothing; user must reply.
 *   'paused'  — sending is locked (channel-share auto-pause).
 */
export function resolveAiMode(input) {
    // Channel-share auto-pause is the strongest gate.
    if (input.channelShareLocked) {
        return { mode: 'paused', reason: 'channel_share_locked', overridden: true };
    }
    // Off-target stance comes next — `block` and `suggest` force Review.
    if (input.offTarget) {
        if (input.offTargetMode === 'block') {
            return { mode: 'review', reason: 'off_target_block', overridden: true };
        }
        if (input.offTargetMode === 'suggest') {
            return { mode: 'review', reason: 'off_target_suggest', overridden: true };
        }
        // 'manual' off-target stance = "Ne rien faire" → treat normally.
        return {
            mode: passthroughForAccount(input.accountMode),
            reason: 'off_target_nothing',
            overridden: false,
        };
    }
    // Hot-lead override forces Review on Auto accounts only.
    if (input.isVeryHot && input.accountMode === 'auto' && input.hotAction === 'validate') {
        return { mode: 'review', reason: 'hot_override_validate', overridden: true };
    }
    return {
        mode: passthroughForAccount(input.accountMode),
        reason: 'account_default',
        overridden: false,
    };
}
function passthroughForAccount(accountMode) {
    return accountMode;
}
//# sourceMappingURL=aiModeResolver.js.map